<template>
  <v-hover v-slot="{ isHovering, props }">
    <v-btn
      v-if="!showCheck"
      v-bind="{ ...props, ...$attrs }"
      :elevation="isHovering ? 5 : 0"
      :color="isHovering ? 'grey-darken-3' : 'grey-lighten-2'"
      width="25px"
      height="25px"
      @click="$emit('insert')"
      class="test-insert-button"
      icon
      size="x-small"
    >
      <v-icon> mdi-plus </v-icon>
    </v-btn>
    <v-btn
      v-else
      v-bind="$attrs"
      color="info"
      width="25px"
      height="25px"
      elevation="0"
      class="test-insert-button"
      icon
      size="x-small"
    >
      <v-icon> mdi-check </v-icon>
    </v-btn>
  </v-hover>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  // The root is a renderless v-hover, so attributes such as `class` from the
  // parent are bound onto the button by hand.
  inheritAttrs: false,
  props: {
    showCheck: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['insert'],
  setup() {
    return {};
  },
});
</script>
